// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"95502f86","225":"e571a5be","743":"3436ce06"}[chunkId] + ".chunk.js";
};